import React from "react";

const CancelIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M10 6L6 9.99974M10 10L6 6.00026" stroke="#E40F03" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M1.66669 8.00008C1.66669 5.01452 1.66669 3.52174 2.59418 2.59424C3.52168 1.66675 5.01446 1.66675 8.00002 1.66675C10.9856 1.66675 12.4784 1.66675 13.4059 2.59424C14.3334 3.52174 14.3334 5.01452 14.3334 8.00008C14.3334 10.9856 14.3334 12.4784 13.4059 13.4059C12.4784 14.3334 10.9856 14.3334 8.00002 14.3334C5.01446 14.3334 3.52168 14.3334 2.59418 13.4059C1.66669 12.4784 1.66669 10.9856 1.66669 8.00008Z" stroke="#E40F03" stroke-width="1.5" />
        </svg>
    )
}
export default CancelIcon;